import { Icon, IconButton, Tooltip, Text } from '@chakra-ui/react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { MdSync, MdSyncProblem } from 'react-icons/md';
import { CellValue } from 'react-table';

import { getVisitsCommonColumn } from 'containers/Evv/shared/visitsCommonColumn';

interface ITableColumn {
  handleSingleSynced: (id: number) => void;
}

export const useTableColumns = ({ handleSingleSynced }: ITableColumn) => {
  const { t } = useTranslation(['common', 'evv']);

  const columns = useMemo(() => {
    const commonColumns = getVisitsCommonColumn(t);

    return [
      ...commonColumns,
      {
        Header: 'Failed Reason',
        accessor: 'visit_status',
        width: 250,
        colStyles: (data: any) => ({
          background: data?.flagged ? 'var(--timeero-colors-secondary-50)' : 'initial',
        }),
        Cell: (data: CellValue) => <Text>{data?.value?.message || '- '}</Text>,
      },
      {
        Header: '',
        accessor: 'action',
        width: 100,
        colStyles: (data: any) => ({
          background: data?.flagged ? 'var(--timeero-colors-secondary-50)' : 'initial',
        }),
        Cell: (data: CellValue) => {
          return (
            <div>
              {data.row.original.visit_status?.status?.value === 'pending' ? (
                <Tooltip label={t('common:sync')} hasArrow bg="black">
                  <IconButton
                    aria-label={t('common:sync')}
                    bg="rgba(38, 103, 201, 0.1)"
                    icon={
                      <Icon
                        as={MdSync}
                        sx={{ '& path:nth-of-type(2)': { fill: 'primary.500' } }}
                        width="1.4em"
                        height="1.4em"
                      />
                    }
                    size="sm"
                    m="1"
                    _hover={{ bg: 'rgba(38, 103, 201, 0.2)' }}
                    onClick={() => handleSingleSynced(data.row.original.id)}
                  />
                </Tooltip>
              ) : (
                <Tooltip label={t('evv:resubmit')} hasArrow bg="black">
                  <IconButton
                    aria-label={t('evv:resubmit')}
                    bg="rgba(255, 83, 83, 0.1)"
                    icon={
                      <Icon
                        as={MdSyncProblem}
                        sx={{ '& path:nth-of-type(2)': { fill: 'newRed.1000' } }}
                        width="1.4em"
                        height="1.4em"
                      />
                    }
                    m="1"
                    size="sm"
                    _hover={{ bg: 'rgba(255, 83, 83, 0.2)' }}
                    onClick={() => handleSingleSynced(data.row.original.id)}
                  />
                </Tooltip>
              )}
            </div>
          );
        },
      },
    ];

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleSingleSynced]);

  return { columns };
};
